import React from 'react';
import { StyleSheet } from 'react-native';

import { Container, DisplayText, TitleText } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { NotFoundScreen } from '../NotFoundScreen';

export const HsaFsaScreen = () => {
  const isFlexEnabled = useFeatureFlag('CELS-5522-flex-enabled');

  if (!isFlexEnabled) {
    return <NotFoundScreen />;
  }

  return (
    <Container style={styles.container}>
      <DisplayText>Coming soon</DisplayText>
      <TitleText>HSA/FSA</TitleText>
    </Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: 64,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
